export { onSendMagicLoginEmail }

import { getContext } from 'telefunc'
import { getCustomerByEmail } from '../../server/db/queries.ts'
import { sendMagicLoginEmail } from '../../server/auth/sendMagicLoginEmail.ts'
import { checkRateLimit } from '../../server/checkRateLimit.ts'
import type { TelefuncContext } from '../../server/auth/telefuncContext.ts'

type SendMagicLoginResult = { kind: 'sent' } | { kind: 'unknown' } | { kind: 'rateLimited' }

// Unauthenticated — anyone can call it (no `getCustomerOrAbort`). Returns 'unknown' for
// the not-found case rather than aborting: the dashboard audience is developers, not
// enumeration-attack targets, so honest feedback beats the anti-enumeration veneer.
//
// Per-IP rate limit: 5 send-requests / minute. Prevents an attacker from harassing a
// known customer's inbox with magic-link emails on a tight loop.
async function onSendMagicLoginEmail(email: string): Promise<SendMagicLoginResult> {
  const { env, ip } = getContext<TelefuncContext>()
  // Gate on IP presence here (absent in `vike dev`); `checkRateLimit` owns the
  // binding-absent ⇒ allow rule.
  if (ip && !(await checkRateLimit(env.RATE_LIMIT_MAGIC_LOGIN, ip))) return { kind: 'rateLimited' }
  const customer = await getCustomerByEmail(email, env)
  if (!customer) return { kind: 'unknown' }
  await sendMagicLoginEmail({ email: customer.email, customerId: customer.id, reason: 'requested' }, env)
  return { kind: 'sent' }
}
